module.exports = __webpack_public_path__ + "img/ssd.67001d2a.svg";